import { LegalPage } from './LegalPage'

export function CGVPage() {
  return (
    <LegalPage
      title="Conditions Générales de Vente"
      subtitle="Version 1.0 — Entrée en vigueur : 15 mars 2026 — Applicables aux abonnements payants"
    >
      <p>Les présentes Conditions Générales de Vente (ci-après "CGV") complètent les CGU et s'appliquent exclusivement aux relations commerciales entre TremorApp SAS et tout client souscrivant à un abonnement payant. En cas de contradiction entre les CGU et les CGV, les CGV prévalent pour les aspects commerciaux.</p>

      <h2>Article 14 — Plans d'abonnement et tarifs</h2>
      <h3>14.1 Plans disponibles</h3>
      <table>
        <thead><tr><th>Plan</th><th>Prix mensuel HT</th><th>Prix annuel HT</th><th>Utilisateurs</th><th>Modules</th></tr></thead>
        <tbody>
          <tr><td>Starter</td><td>149 €</td><td>1 490 € (−17%)</td><td>3</td><td>2 au choix</td></tr>
          <tr><td>Pro Agence</td><td>349 €</td><td>3 490 € (−17%)</td><td>Illimité</td><td>4 modules complets</td></tr>
          <tr><td>Entreprise</td><td>Sur devis</td><td>Sur devis</td><td>Illimité</td><td>4 + options custom</td></tr>
        </tbody>
      </table>
      <p>Tous les prix sont exprimés en euros hors taxes (HT). La TVA applicable est celle en vigueur à la date de facturation (20% pour les clients établis en France).</p>

      <h3>14.2 Essai gratuit</h3>
      <p>Tout nouveau compte bénéficie d'une période d'essai gratuite de 14 jours donnant accès à l'ensemble des fonctionnalités du plan Pro Agence. Aucune carte bancaire n'est requise pour démarrer l'essai. À l'issue de la période d'essai, le Service est suspendu si aucun abonnement n'est souscrit.</p>

      <h3>14.3 Modification des tarifs</h3>
      <p>TremorApp se réserve le droit de modifier ses tarifs. Toute modification tarifaire sera notifiée aux clients par email au moins 60 jours avant son entrée en vigueur. Les clients bénéficiant d'un abonnement annuel restent aux conditions tarifaires initiales jusqu'à l'échéance de leur contrat annuel.</p>

      <h2>Article 15 — Commande et souscription</h2>
      <p>La souscription à un plan payant s'effectue exclusivement en ligne via l'interface TremorApp. Le processus de commande comprend :</p>
      <ul>
        <li>Étape 1 : Sélection du plan souhaité dans la section Paramètres → Facturation</li>
        <li>Étape 2 : Saisie des coordonnées de facturation (nom, adresse, numéro TVA si applicable)</li>
        <li>Étape 3 : Saisie des coordonnées bancaires via l'interface sécurisée Stripe</li>
        <li>Étape 4 : Validation de la commande et confirmation par email</li>
      </ul>
      <p>La commande est définitive à réception du email de confirmation. TremorApp se réserve le droit de refuser toute commande en cas de litige antérieur ou de suspicion de fraude.</p>

      <h2>Article 16 — Facturation et paiement</h2>
      <h3>16.1 Modalités de facturation</h3>
      <p>Les abonnements sont facturés en début de période (prépaiement) selon le cycle choisi :</p>
      <ul>
        <li>Mensuel : facturation le même jour chaque mois</li>
        <li>Annuel : facturation en une seule fois pour 12 mois</li>
      </ul>
      <p>Les factures sont émises sous format PDF et accessibles dans le Dashboard de facturation.</p>

      <h3>16.2 Moyens de paiement acceptés</h3>
      <p>TremorApp accepte les moyens de paiement suivants via Stripe :</p>
      <ul>
        <li>Cartes bancaires : Visa, Mastercard, American Express</li>
        <li>Virement SEPA (sur demande pour les plans Entreprise)</li>
        <li>Prélèvement automatique SEPA</li>
      </ul>

      <h3>16.3 Défaut de paiement</h3>
      <p>En cas d'échec de paiement, TremorApp procède à deux nouvelles tentatives automatiques à J+3 et J+7. En l'absence de régularisation à J+10, le Service est suspendu sans préjudice de toute action en recouvrement.</p>
      <p>Les sommes impayées portent intérêt au taux légal majoré de 5 points à compter du 31ème jour suivant la date d'échéance. Conformément à l'article L.441-10 du Code de commerce, une indemnité forfaitaire de 40 € est applicable pour frais de recouvrement.</p>

      <h3>16.4 Factures et TVA</h3>
      <p>Pour les clients assujettis à la TVA établis dans l'Union Européenne (hors France), la facturation s'effectue en reverse charge (autoliquidation de TVA). Le client doit fournir son numéro de TVA intracommunautaire valide lors de la commande.</p>

      <h2>Article 17 — Droit de rétractation</h2>
      <div className="note">TremorApp étant exclusivement destiné aux professionnels (B2B), les dispositions relatives au droit de rétractation des consommateurs (art. L.221-18 C. conso.) ne sont pas applicables. Les clients professionnels ne bénéficient pas du droit de rétractation légal.</div>
      <p>Toutefois, par souci de satisfaction client, TremorApp offre une garantie satisfait ou remboursé de 30 jours sur les premiers abonnements Starter et Pro Agence. Cette garantie est exercée en contactant billing@tremor.fr dans les 30 jours suivant la première facturation payante.</p>

      <h2>Article 18 — Renouvellement et résiliation</h2>
      <h3>18.1 Renouvellement automatique</h3>
      <p>Les abonnements sont tacitement reconduits à leur échéance pour une durée identique, au tarif en vigueur au moment du renouvellement. Le client reçoit un email de notification 14 jours avant chaque renouvellement annuel.</p>

      <h3>18.2 Résiliation par le client</h3>
      <p>Le client peut résilier son abonnement à tout moment depuis l'interface Paramètres → Facturation → Résilier mon abonnement. La résiliation prend effet à la fin de la période de facturation en cours.</p>
      <table>
        <thead><tr><th>Type d'abonnement</th><th>Délai de résiliation</th><th>Remboursement</th></tr></thead>
        <tbody>
          <tr><td>Mensuel</td><td>Avant la prochaine date de renouvellement</td><td>Non — service maintenu jusqu'à échéance</td></tr>
          <tr><td>Annuel</td><td>À tout moment</td><td>Non (sauf garantie 30j sur 1er abonnement)</td></tr>
          <tr><td>Entreprise</td><td>Selon conditions contractuelles spécifiques</td><td>Selon contrat</td></tr>
        </tbody>
      </table>

      <h3>18.3 Résiliation pour faute</h3>
      <p>En cas de manquement grave du client à ses obligations, TremorApp peut résilier l'abonnement avec effet immédiat par email, sans remboursement des sommes déjà versées.</p>

      <h2>Article 19 — Garanties et niveaux de service (SLA)</h2>
      <table>
        <thead><tr><th>Indicateur SLA</th><th>Starter</th><th>Pro Agence</th><th>Entreprise</th></tr></thead>
        <tbody>
          <tr><td>Disponibilité garantie</td><td>99,0%</td><td>99,5%</td><td>99,9% (contractuel)</td></tr>
          <tr><td>Délai de réponse support</td><td>72h ouvrées</td><td>24h ouvrées</td><td>4h ouvrées</td></tr>
          <tr><td>Canal support</td><td>Email</td><td>Email + chat</td><td>Email + chat + téléphone</td></tr>
          <tr><td>Compensation indisponibilité</td><td>Avoir max 10%</td><td>Avoir max 25%</td><td>Selon SLA contractuel</td></tr>
          <tr><td>Backup des données</td><td>Quotidien</td><td>Quotidien</td><td>Temps réel (selon contrat)</td></tr>
        </tbody>
      </table>

      <h2>Article 20 — Données du client et portabilité</h2>
      <p>Les données créées ou importées par le client dans TremorApp sont et restent la propriété exclusive du client.</p>
      <p>À tout moment, le client peut :</p>
      <ul>
        <li>Exporter ses données depuis l'interface (CSV, JSON selon les modules)</li>
        <li>Demander un export global à support@tremor.fr</li>
        <li>Demander la suppression de toutes ses données à privacy@tremor.fr</li>
      </ul>
      <p>À compter de la résiliation effective, TremorApp conserve les données du client pendant 30 jours calendaires. Passé ce délai, les données sont définitivement supprimées.</p>

      <h2>Article 21 — Confidentialité et secret des affaires</h2>
      <p>TremorApp s'engage à traiter comme strictement confidentielles toutes les informations relatives au client. Cet engagement s'étend à l'ensemble des collaborateurs et sous-traitants de TremorApp et survit pendant 5 ans après la résiliation du contrat.</p>
      <p>Le client reconnaît que les algorithmes, modèles de calcul et méthodes analytiques de TremorApp constituent des secrets d'affaires au sens de la directive (UE) 2016/943.</p>

      <h2>Article 22 — Force majeure</h2>
      <p>TremorApp ne pourra être tenue responsable de l'inexécution de ses obligations en cas de force majeure, telle que définie par l'article 1218 du Code civil français, incluant notamment : catastrophes naturelles, attaques informatiques de grande ampleur, pannes généralisées d'infrastructures internet, décisions gouvernementales d'urgence.</p>
      <p>En cas de force majeure d'une durée supérieure à 30 jours consécutifs, chaque partie pourra résilier le contrat sans indemnité.</p>

      <h2>Article 23 — Références commerciales</h2>
      <p>Sauf opposition expresse du client notifiée par email à hello@tremor.fr, TremorApp se réserve le droit de mentionner le nom et le logo du client à titre de référence commerciale.</p>

      <h2>Article 24 — Cession du contrat</h2>
      <p>Le client ne peut céder tout ou partie de ses droits et obligations sans l'accord préalable écrit de TremorApp. TremorApp peut librement céder le présent contrat dans le cadre d'une fusion, acquisition ou cession d'activité.</p>

      <h2>Article 25 — Dispositions finales</h2>
      <p>Si une ou plusieurs stipulations des présentes CGV sont tenues pour non valides, les autres stipulations garderont toute leur force et leur portée.</p>

      <h2>Contacts</h2>
      <table className="contact-table">
        <thead><tr><th>Contact</th><th>Email</th><th>Objet</th></tr></thead>
        <tbody>
          <tr><td>Support général</td><td><a href="mailto:support@tremor.fr">support@tremor.fr</a></td><td>Questions techniques, bugs, assistance</td></tr>
          <tr><td>Facturation</td><td><a href="mailto:billing@tremor.fr">billing@tremor.fr</a></td><td>Factures, paiements, remboursements</td></tr>
          <tr><td>Données personnelles / RGPD</td><td><a href="mailto:privacy@tremor.fr">privacy@tremor.fr</a></td><td>Exercice des droits RGPD</td></tr>
          <tr><td>Questions juridiques</td><td><a href="mailto:legal@tremor.fr">legal@tremor.fr</a></td><td>CGU, CGV, contentieux</td></tr>
          <tr><td>Sécurité</td><td><a href="mailto:security@tremor.fr">security@tremor.fr</a></td><td>Signalement de failles ou incidents</td></tr>
        </tbody>
      </table>

      <p style={{ textAlign: 'center', marginTop: '3rem', fontSize: '0.75rem', color: '#9A917F' }}>
        Document mis à jour le 15 mars 2026 — Version 1.0
      </p>
    </LegalPage>
  )
}
